"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delayedRedirect = void 0;

var _redirect = _interopRequireDefault(require("@insided/deprecated-utils/redirect"));

var delayedRedirect = function delayedRedirect(url) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  // eslint-disable-next-line no-console
  console.log("[delayedRedirect] Redirecting to ".concat(url));
  setTimeout(function () {
    (0, _redirect.default)(url);
  }, delay);
};

exports.delayedRedirect = delayedRedirect;